export default __webpack_public_path__ + "static/media/PicUpload.afa7de68.jpg";